export default __webpack_public_path__ + "static/media/icon_password_outline.a0f5b7f9.svg";